import React, { CSSProperties } from "react";
import classnames from "classnames";
import { Link } from "gatsby";
import styles from "./layout.module.scss";
import MenuCategories from "./MenuCategories";
import { NewsletterBox } from "./NewsletterBox";

interface LayoutProps {
  className?: string;
  styles?: CSSProperties;
}

const Layout: React.FC<LayoutProps> = props => {
  const { children, className, styles: htmlStyles = {} } = props;

  return (
    <div>
      <div className={className} style={{ ...htmlStyles, paddingBottom: 100 }}>
        <div className={styles.grid_menu + " " + "px-5"}>
          <div className={classnames(styles.menu, styles.left_menu)}>
            <Link
              to="/"
              className={styles.menu_item}
              activeClassName="bg-white bg-opacity-20"
            >
              About
            </Link>
            <Link
              to="/blog"
              className={styles.menu_item}
              activeClassName="bg-white bg-opacity-20"
            >
              Blog
            </Link>
            <Link
              to="/calculators"
              className={styles.menu_item}
              activeClassName="bg-white bg-opacity-20"
            >
              Tools
            </Link>
            <Link
              to="/portfolio"
              className={styles.menu_item}
              activeClassName="bg-white bg-opacity-20"
            >
              Portfolio
            </Link>
          </div>
          <div className={classnames(styles.menu, styles.right_menu)}>
            <MenuCategories />
            <Link to="/cv" className={styles.menu_item}>
              CV
            </Link>
          </div>
        </div>
        {children}
      </div>
      <footer>
        <NewsletterBox />
      </footer>
    </div>
  );
};

export default Layout;
